<script setup lang="ts">
/**
 * Шаблон «Классическая плитка» — исторический вид каталога и дефолт для всех заведений:
 * бейджи поверх фото, квадратное фото, название и цена по центру, круглая кнопка «+».
 */
import { PRODUCT_CARD_PROP_DEFAULTS, type ProductCardEmits, type ProductCardProps } from './cardContract';
import { getCardDescription } from '@entities/product';

const props = withDefaults(defineProps<ProductCardProps>(), PRODUCT_CARD_PROP_DEFAULTS);
const emit = defineEmits<ProductCardEmits>();

const description = computed(() => getCardDescription(props.item));
</script>

<template>
  <div
    class="pcard pcard--classic"
    :class="[`pcard--surface-${config.surface}`, `pcard--align-${config.textAlign}`]"
    :data-testid="`product-card-${item.id}`"
    @click="emit('open')"
  >
    <ProductBadges
      v-if="config.showBadges"
      :tags="item.tags"
      :teg="item.teg"
      size="sm"
      :max-visible="4"
      class-name="pcard__badges"
    />

    <ProductCardFavorite
      v-if="favoriteEnabled"
      class="pcard__favorite"
      :active="!!item.is_favorite"
      :animation="favoriteAnimation"
      @click="emit('favorite')"
    />

    <ProductCardMedia :item="item" :aspect="config.imageAspect" :placeholder="placeholder" :priority="priority" />

    <div class="pcard__body">
      <h3 class="pcard__title">
        <!-- Ссылка, а не текст: карточка открывается модалкой, и без href у блюда
             не было ни одного адреса, по которому его мог бы найти поиск. Клик
             гасим — поведение витрины остаётся прежним, но Ctrl+клик и
             «скопировать адрес ссылки» теперь работают. -->
        <a v-if="href" :href="href" class="pcard__title-link" @click.prevent="emit('open')">{{ item.name }}</a>
        <template v-else>{{ item.name }}</template>
      </h3>
      <p v-if="config.showDescription && description" class="pcard__description">{{ description }}</p>
    </div>

    <div class="pcard__bottom pcard__bottom--with-action">
      <ProductCardPrice class="pcard__price" :item="item" :variant="config.priceStyle" />
      <ProductCardAction
        :in-cart="inCart"
        :cart-quantity="cartQuantity"
        :variant="config.actionStyle"
        :data-testid="inCart ? `product-card-incart-${item.id}` : `product-card-add-${item.id}`"
        @click="emit('action')"
      />
    </div>
  </div>
</template>
